// import { setting } from '@/config/setting';
// const { tokenTableName } = setting;
const tokenTableName="access_token" 
import Cookies from 'js-cookie';
export function getAccessToken() {
  return Cookies.get(tokenTableName);
}

export function setAccessToken(accessToken) {
  return Cookies.set(tokenTableName, accessToken);
}

export function removeAccessToken() {
  return Cookies.remove(tokenTableName);
}



// WEBPACK FOOTER //
// ./src/utils/accessToken.js